import { AxiosInstance } from "axios";
import {
  fetchObjectTypeIdByAliasUrl,
  fetchPropertyIdByAliasUrl,
  fetchObjectClassIdByAliasUrl,
  fetchWorkflowStateIdByAliasUrl,
  fetchWorkflowIdByAliasUrl,
  parseTokenFromQueryString,
} from "../helpers/urlHelper";

const getAliasesFromIdsNoBatchAsync = async (httpClient: AxiosInstance, url: string, aliases: string[]) => {
  const promises = [];
  for(const alias of aliases) {
    promises.push( httpClient.get(`${url}/${alias}`) )
  }
  const responses = await Promise.all(promises);
  const ret = {};
  for(let i = 0; i < aliases.length; i++) {
    const alias = aliases[i];
    const response = responses[i];
    ret[alias] = response.data;
  }
  return ret;
};

const getAliasesFromIdsAsync = async (httpClient: AxiosInstance, url: string, aliases: string[]) => {
  //Fallback to nobatch version, since readonly session can't handle post-methods
  if(parseTokenFromQueryString()) {
    return getAliasesFromIdsNoBatchAsync(httpClient, url, aliases);
  }
  const response = await httpClient.post(url, aliases);
  return response.data;
};

export const getObjectTypeIdsFromAliasesAsync = async (httpClient: AxiosInstance, objectTypeAliases: string[]): Promise<unknown> => {
  return getAliasesFromIdsAsync(httpClient, fetchObjectTypeIdByAliasUrl(), objectTypeAliases);
};

export const getObjectClassIdsFromAliasesAsync = async (httpClient: AxiosInstance, objectClassAliases: string[]): Promise<unknown> => {
  return getAliasesFromIdsAsync(httpClient, fetchObjectClassIdByAliasUrl(), objectClassAliases);
};

export const getWorkflowStateIdsFromAliasesAsync = async (httpClient: AxiosInstance, workflowStateAliases: string[]): Promise<unknown> => {
  return getAliasesFromIdsAsync(httpClient, fetchWorkflowStateIdByAliasUrl(), workflowStateAliases);
};

export const getWorkflowIdsFromAliasesAsync = async (httpClient: AxiosInstance, workflowAliases: string[]): Promise<unknown> => {
  return getAliasesFromIdsAsync(httpClient, fetchWorkflowIdByAliasUrl(), workflowAliases);
};

export const getPropertyIdsFromAliasesAsync = async (httpClient: AxiosInstance, propertyAliases: string[]): Promise<unknown> => {
  return getAliasesFromIdsAsync(httpClient, fetchPropertyIdByAliasUrl(), propertyAliases);
};
